import { KYMW0300OutputModel } from '../../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW1102Model } from '../kymw1102.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品情報初期処理クラス
 *
 * @export GetSelectInfoService
 * @class GetSelectInfoService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetSelectInfoService extends PlessJsonResponderSub<any> {


  // リスト区切り文字
  private readonly SPLIT_TOKEN: string = <string>'★';

  // VO
  private vo: KYMW0300OutputModel = new KYMW0300OutputModel;
  // 処理に使用するModel
  private model: KYMW1102Model;
  private successFunc: Function;

  private registDate: string = <string>'';
  private updateDate: string = <string>'';
  private guideGoodsName: string = <string>'';
  private guideStandardName: string = <string>'';
  private coopCode: string = <string>'';
  private pCoods: string = <string>'';
  private itemCodeList: string = <string>'';
  private tagIdList: string = <string>'';
  private goodsMarkCodeList: string = <string>'';

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSelectInfoService
   */
  private getBody(): PlessRequest {
    const dutiesFormDailies = this.vo.dutiesFormDailyList.map(k => ({
      parameter: {
        DutiesFormDailyDiv: k
      }
    }));

    return new PlessRequest({
      search: {
        Rec: {
          parameter: {
            PCode: this.vo.pcode,
            ItemCode: this.vo.itemCode,
            JanCode: this.vo.janCode,
            MakerName: this.vo.makerName,
            TagSearchType: this.vo.tagSearchType,
            GoodsMarkSearchType: this.vo.goodsMarkSearchType,
            DataKbnFlg: this.vo.dataKbnFlg,
            GoodsDiv: this.vo.goodsDiv,
            OrderClientCode: this.vo.ordrClientCode,
            OrderClientKanji: this.vo.ordrClientKanji,
            PayeeClientCode: this.vo.payeeClientCode,
            PayeeClientKanji: this.vo.payeeClientKanji,
            ClassCode: this.vo.classCode,
            MiddleClassCode: this.vo.middleClassCode,
            SmallClassCode: this.vo.smallClassCode,
            RegistDateFrom: this.vo.registDateFrom,
            RegistDateTo: this.vo.registDateTo,
            UpdateDateFrom: this.vo.updateDateFrom,
            UpdateDateTo: this.vo.updateDateTo,
            AdmitStatus: this.vo.admitStatus,
            BuyerCode: this.vo.buyerCode,
            GuideGoodsNameList: this.guideGoodsName,
            GuideStandardNameList: this.guideStandardName,
            CoopCodeList: this.coopCode,
            PcodeList: this.pCoods,
            ItemCodeList: this.itemCodeList,
            TagIdList: this.tagIdList,
            GoodsMarkCodeList: this.goodsMarkCodeList,
          },
          combination: dutiesFormDailies
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof GetSelectInfoService
   */
  execute(model: KYMW1102Model, vo: KYMW0300OutputModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.getSelectInfo(vo);
    this.send('getSelectInfo', this.getBody());
  }

  getSelectInfo(vo: KYMW0300OutputModel) {
    if (vo.registDateCheck) {
      this.registDate = '1';
    } else {
      this.registDate = '0';
    }
    if (vo.updateDateCheck) {
      this.updateDate = '1';
    } else {
      this.updateDate = '0';
    }

    this.guideGoodsName = <string>'';
    let index: number = <number>0;
    for (const gdGdsNm of vo.guideGoodsNameList) {
      if (vo.guideGoodsNameList.length - 1 !== index) {
        this.guideGoodsName += gdGdsNm;
        this.guideGoodsName += this.SPLIT_TOKEN;
      } else {
        this.guideGoodsName += gdGdsNm;
      }
      index++;
    }

    this.guideStandardName = <string>'';
    index = 0;
    for (const gdStdNm of vo.guideStandardNameList) {
      if (vo.guideStandardNameList.length - 1 !== index) {
        this.guideStandardName += gdStdNm;
        this.guideStandardName += this.SPLIT_TOKEN;
      } else {
        this.guideStandardName += gdStdNm;
      }
      index++;
    }

    this.coopCode = <string>'';
    index = 0;
    for (const cpCd of vo.coopCodeList) {
      if (vo.coopCodeList.length - 1 !== index) {
        this.coopCode += cpCd;
        this.coopCode += this.SPLIT_TOKEN;
      } else {
        this.coopCode += cpCd;
      }
      index++;
    }

    this.pCoods = <string>'';
    index = 0;
    for (const pCd of vo.pcodeList) {
      if (vo.pcodeList.length - 1 !== index) {
        this.pCoods += pCd;
        this.pCoods += this.SPLIT_TOKEN;
      } else {
        this.pCoods += pCd;
      }
      index++;
    }

    this.itemCodeList = <string>'';
    index = 0;
    for (const iCd of vo.itemcodeList) {
      if (vo.itemcodeList.length - 1 !== index) {
        this.itemCodeList += iCd;
        this.itemCodeList += this.SPLIT_TOKEN;
      } else {
        this.itemCodeList += iCd;
      }
      index++;
    }

    this.tagIdList = <string>'';
    index = 0;
    for (const tId of vo.tagId) {
      if (vo.tagId.length - 1 !== index) {
        this.tagIdList += tId;
        this.tagIdList += this.SPLIT_TOKEN;
      } else {
        this.tagIdList += tId;
      }
      index++;
    }

    this.goodsMarkCodeList = <string>'';
    index = 0;
    for (const gdMk of vo.goodsMark) {
      if (vo.goodsMark.length - 1 !== index) {
        this.goodsMarkCodeList += gdMk;
        this.goodsMarkCodeList += this.SPLIT_TOKEN;
      } else {
        this.goodsMarkCodeList += gdMk;
      }
      index++;
    }
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSelectInfoService
   */
  success(data: any): void {
    if (!data.length) {
      // E0100メッセージ表示
      this.model.kymw1102Component.dialogService.openAlertGetMessage('E0100');
    }

    this.model.setSelectInfoData(data);
    // レスポンスのファイルパスをマネージに保存
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
